import PropTypes from 'prop-types';
import React from 'react';

import Globe from '@apps-common/react-globe';

import MapTool from '@apps-common/ui-maps/MapTool';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import {Box, Tooltip} from '@mui/material';

import {trackEvent} from '@app/analytics';

import useMapViewParams from '@app/hooks/useMapViewParams';
import {useTheme} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';

const ZoomControls = props => {
  const theme = useTheme();
  const {t} = useTranslation();
  const {center, zoom, setLocation} = useMapViewParams();

  const onZoom = newZoom => {
    if (newZoom < props.minZoom || newZoom > props.maxZoom) {
      return;
    }

    setLocation(center, newZoom);
  };

  const onZoomIn = () => {
    trackEvent('Zoom Controls', {
      action: 'Zoom in',
    });
    onZoom(Math.floor(zoom + 1));
  };

  const onZoomOut = () => {
    trackEvent('Zoom Controls', {
      action: 'Zoom out',
    });
    onZoom(Math.ceil(zoom - 1));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        maxWidth: 'inherit',
      }}
    >
      <Tooltip placement="left">
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <MapTool
            icon={<AddIcon />}
            disabled={zoom >= props.maxZoom}
            tooltipTitle={t('zoomTools.zoomIn')}
            onClick={onZoomIn}
            sx={{
              borderRadius: '4px 4px 0 0',
              boxShadow: 'none',
            }}
            data-testid="zoom-in"
          />
          <MapTool
            icon={<RemoveIcon />}
            disabled={zoom <= props.minZoom}
            tooltipTitle={t('zoomTools.zoomOut')}
            onClick={onZoomOut}
            sx={{
              borderRadius: 0,
              boxShadow: 'none',
            }}
            data-testid="zoom-out"
          />
        </Box>
      </Tooltip>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 40,
          height: 60,
          bgcolor: 'background.paper',
        }}
        data-testid="globe"
      >
        <Globe
          center={center}
          markerColor="#00A0B4"
          landColor={theme.palette.grey[500]}
          waterColor="#fff"
        />
      </Box>
      {props.additionalControls}
    </Box>
  );
};

ZoomControls.propTypes = {
  maxZoom: PropTypes.number,
  minZoom: PropTypes.number,
  additionalControls: PropTypes.node,
};

export default ZoomControls;
